"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _clsx2 = _interopRequireDefault(require("clsx"));

var _styles = require("@material-ui/core/styles");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _colorManipulator = require("@material-ui/core/styles/colorManipulator");

var styles = function styles(theme) {
  return {
    /**
     * Styles applied to the root element.
     */
    dots: {
      position: 'absolute',
      bottom: '5px',
      textAlign: 'center',
      width: '100%'
    },

    /**
     * Styles applied to the dot representing the selected slide.
     */
    dotSelected: {
      backgroundColor: theme.palette.text.primary
    },

    /**
     * Styles applied to each dot element.
     */
    dot: {
      backgroundColor: (0, _colorManipulator.fade)(theme.palette.text.primary, 0.25),
      width: 8,
      height: 8,
      borderWidth: '1px',
      borderStyle: 'solid',
      borderColor: theme.palette.background.paper,
      borderRadius: '50%',
      display: 'inline-block',
      margin: '0 2px',
      // Same duration as SwipeableViews animation
      transitionDuration: '0.35s'
    }
  };
};

var useStyles = (0, _styles.makeStyles)(styles, {
  name: 'RSFCarouselDots'
});
/**
 * An overlay shown at the bottom of a [`Carousel`](/apiReference/carousel/Carousel) that shows a
 * sequence of dots representing the slides in the Carousel.
 */

function CarouselDots(_ref) {
  var selected = _ref.selected,
      count = _ref.count,
      classes = _ref.classes;
  var dots = [];
  classes = useStyles({
    classes: classes
  });

  for (var i = 0; i < count; i++) {
    var _clsx;

    dots.push( /*#__PURE__*/_react["default"].createElement("div", {
      key: i,
      className: (0, _clsx2["default"])((_clsx = {}, (0, _defineProperty2["default"])(_clsx, classes.dot, true), (0, _defineProperty2["default"])(_clsx, classes.dotSelected, selected === i), _clsx))
    }));
  }

  return /*#__PURE__*/_react["default"].createElement("div", {
    className: classes.dots
  }, dots);
}

CarouselDots.propTypes = {
  /**
   * Override or extend the styles applied to the component. See [CSS API](#css) below for more details.
   */
  classes: _propTypes["default"].object,

  /**
   * The total number of dots to show.
   */
  count: _propTypes["default"].number.isRequired,

  /**
   * The index of the selected dot.
   */
  selected: _propTypes["default"].number.isRequired
};

var _default = /*#__PURE__*/_react["default"].memo(CarouselDots);

exports["default"] = _default;
//# sourceMappingURL=CarouselDots.js.map